// JavaScript Document
// =================================================
// FVアニメーション
// =================================================
(() => {
  const TARGET_ID = 'js-fvAnimation';
  const DEFAULT_DELAY_SECONDS = 0.6;
  const isFirstLoad = sessionStorage.getItem('isFirstLoad'); // 文字列 or null

  // 要素が後から挿入される可能性も考慮
  const whenFvReady = (cb) => {
    const el = document.getElementById(TARGET_ID);
    if (el) return cb(el);
    const obs = new MutationObserver(() => {
      const el2 = document.getElementById(TARGET_ID);
      if (el2) { obs.disconnect(); cb(el2); }
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  };

  // window.load（画像や外部リソース含む完全読込）まで待つ Promise
  const waitForWindowLoad = () => new Promise((resolve) => {
    if (document.readyState === 'complete') return resolve();
    window.addEventListener('load', resolve, { once: true });
  });

  if (!isFirstLoad) {
    // ---- 初回（セッション未設定など）だけ実行 ----
    whenFvReady(async (fv) => {
      if (document.readyState !== 'complete') {
        await waitForWindowLoad();
      }
      const attr = parseFloat(fv.getAttribute('data-anim-delay-seconds'));
      const delaySec = Number.isFinite(attr) ? attr : DEFAULT_DELAY_SECONDS;

      setTimeout(() => {
        if (!fv.classList.contains('js-animation-active')) {
          fv.classList.add('js-animation-active');
        }
      }, Math.max(0, delaySec * 1000));
      sessionStorage.setItem('isFirstLoad','1')
    });
  } else {
    // ---- 2回目以降：要素を削除（後挿入にも対応）----
    const removeTarget = () => {
      const el = document.getElementById(TARGET_ID);
      if (el && el.parentNode) el.parentNode.removeChild(el);
    };
    if (document.getElementById(TARGET_ID)) {
      removeTarget();
    } else {
      const obs = new MutationObserver(() => {
        const el2 = document.getElementById(TARGET_ID);
        if (el2) { obs.disconnect(); removeTarget(); }
      });
      obs.observe(document.documentElement, { childList: true, subtree: true });
    }
  }
})();

// =================================================
// MVアニメーション
// =================================================
// ユーティリティ：一定時間待機
const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

/**
 * el配下の.mainvisual_pht_itemを順番にアクティブ化してループ再生
 * @param {Element} el - 親要素
 * @param {Object} options
 * @param {number} [options.seconds=1] - アクティブ保持秒数
 * @param {number} [options.between=0.2] - 次の要素に移る前の待機秒数
 * @param {string} [options.selector='.mainvisual_pht_item']
 * @param {string} [options.activeClass='js-slide-item-active']
 * @param {AbortSignal} [options.signal] - 停止用 signal
 */
async function slideItemsLoop(
  el,
  {
    seconds = 1,
    between = 0.2,
    selector = '.mainvisual_pht_item',
    activeClass = 'js-slide-item-active',
    signal
  } = {}
) {
  if (!el) return;
  const items = Array.from(el.querySelectorAll(selector));
  if (!items.length) return;

  let index = 0;
  while (true) {
    if (signal?.aborted) break;

    const item = items[index];
    item.classList.add(activeClass);

    await wait(seconds * 1000);
    item.classList.remove(activeClass);

    if (signal?.aborted) break;

    await wait(between * 1000);

    index = (index + 1) % items.length; // 最後までいったら先頭へ
  }
}

/* --- 使い方例 --- */
// const controller = new AbortController();
// slideItemsLoop(el, { seconds: 1.5, between: 0.3, signal: controller.signal });

// 止めたいときは
// controller.abort();



// anim01: #js-mv01 に .js-animation-active を付与/除去（順方向=付与 / 逆方向=除去）
// 使い方：
//   await anim01();                 // 順方向: 付与
//   await anim01({ reverse: true }); // 逆方向: 除去
window.anim01 = function anim01(options = {}) {
  const { reverse = false, shortFallbackMs = 50, longFallbackMs = 15000 } = options;
  const el = document.getElementById('js-mv01');
  if (!el) return Promise.resolve();

  const CLS = 'js-animation-active';
  const shouldAdd = !reverse;
  const has = el.classList.contains(CLS);

  // すでに目標状態なら即終了
  if ((shouldAdd && has) || (!shouldAdd && !has)) {
    return Promise.resolve();
  }

  return new Promise((resolve) => {
    let finished = false;
    let pending = 0;
    let microT;

    const finish = () => {
      if (finished) return;
      finished = true;
      cleanup();
      resolve();
    };

    const inc = () => { pending += 1; };
    const dec = () => {
      pending = Math.max(0, pending - 1);
      clearTimeout(microT);
      // 連続 end をまとめて確定
      microT = setTimeout(() => { if (pending === 0) finish(); }, 0);
    };

    // 子要素も含めて検知（capture: true）
    const onAnimStart = (e) => { if (el.contains(e.target)) inc(); };
    const onAnimEnd   = (e) => { if (el.contains(e.target)) dec(); };
    const onTransRun  = (e) => { if (el.contains(e.target)) inc(); };
    const onTransEnd  = (e) => { if (el.contains(e.target)) dec(); };

    el.addEventListener('animationstart',   onAnimStart, true);
    el.addEventListener('animationend',     onAnimEnd,   true);
    el.addEventListener('animationcancel',  onAnimEnd,   true);
    el.addEventListener('transitionrun',    onTransRun,  true);
    el.addEventListener('transitionend',    onTransEnd,  true);
    el.addEventListener('transitioncancel', onTransEnd,  true);

    const shortTimer = setTimeout(() => { if (pending === 0) finish(); }, Math.max(0, shortFallbackMs));
    const longTimer  = setTimeout(finish, Math.max(0, longFallbackMs));

    function cleanup() {
      clearTimeout(shortTimer);
      clearTimeout(longTimer);
      clearTimeout(microT);
      el.removeEventListener('animationstart',   onAnimStart, true);
      el.removeEventListener('animationend',     onAnimEnd,   true);
      el.removeEventListener('animationcancel',  onAnimEnd,   true);
      el.removeEventListener('transitionrun',    onTransRun,  true);
      el.removeEventListener('transitionend',    onTransEnd,  true);
      el.removeEventListener('transitioncancel', onTransEnd,  true);
    }

    // 実処理：付与 or 除去
    if (shouldAdd) {
      el.classList.add(CLS);
    } else {
      el.classList.remove(CLS);
    }
  });
};


// anim02: #js-mv02 配下を data-numb で並べ替えて、順方向は付与 / 逆方向は除去
// 使い方例：
//   await anim02();                 // 付与（小さい→大きい）
//   await anim02({ reverse: true }); // 除去（大きい→小さい）
//
// オプション：
//   reverse    : boolean  … true なら「大きい順に remove」、false なら「小さい順に add」
//   stepMs     : number   … 各要素の処理間の待機(ms)。デフォルト 0
//   waitEach   : boolean  … 各要素の animationend/transitionend を待ってから次へ（デフォルト false）
//   timeoutMs  : number   … waitEach 時のフォールバック最大待機(ms)。デフォルト 1500
window.anim02 = function anim02(options = {}) {
  const {
    reverse   = false,
    stepMs    = 0,
    waitEach  = true,
    timeoutMs = 1500,
  } = options;

  const root = document.getElementById('js-mv02');
  if (!root) return Promise.resolve();

  // 1) 子要素を取得
  const items = Array.from(root.querySelectorAll('.js-mv02-item'))
    .map(el => {
      const n = parseFloat(el.dataset.numb);
      return { el, n };
    })
    // 2) data-numb が数値でないものは除外
    .filter(({ n }) => Number.isFinite(n));

  if (!items.length) return Promise.resolve();

  // 3) data-numb で昇順ソート（付与用）
  items.sort((a, b) => a.n - b.n);

  // 付与時: 昇順のまま / 除去時: 逆順に
  const ordered = reverse ? [...items].reverse() : items;

  // 各要素のアニメ終了を待つ（必要なとき）
  const waitEnd = (el) => new Promise((resolve) => {
    if (!waitEach) return resolve();

    let done = false;
    const finish = () => {
      if (done) return;
      done = true;
      cleanup();
      resolve();
    };
    const onEnd = (e) => {
      // 子孫のイベントがバブリングしても対象のみで判定
      if (e.target !== el) return;
      finish();
    };
    const cleanup = () => {
      el.removeEventListener('animationend', onEnd);
      el.removeEventListener('animationcancel', onEnd);
      el.removeEventListener('transitionend', onEnd);
      el.removeEventListener('transitioncancel', onEnd);
      clearTimeout(timer);
    };

    el.addEventListener('animationend', onEnd);
    el.addEventListener('animationcancel', onEnd);
    el.addEventListener('transitionend', onEnd);
    el.addEventListener('transitioncancel', onEnd);

    const timer = setTimeout(finish, Math.max(0, timeoutMs));
  });

  // 処理間ウェイト
  const delay = (ms) => (ms > 0 ? new Promise(r => setTimeout(r, ms)) : Promise.resolve());

  // 4) 実行（順方向: add / 逆方向: remove）
  return ordered.reduce((p, { el }) => {
    return p.then(async () => {
      if (reverse) {
        el.classList.remove('js-animation-active');
      } else {
        el.classList.add('js-animation-active');
      }
      await waitEnd(el);
      await delay(stepMs);
    });
  }, Promise.resolve());
};




//実行
document.addEventListener('DOMContentLoaded', () => {
  const TARGET_SEL = '#js-mv01';
  const mv = document.querySelector(TARGET_SEL);
  let controller;
  function startSlide() {
    // 新しいコントローラを作り直す
    controller = new AbortController();
    slideItemsLoop(mv, {
      seconds: 5,
      between: 0,
      signal: controller.signal
    });
  }
  if (!mv) return;
  //startSlide();

  // ===== 設定 =====
  const SEQUENCE_GAP_MS = 200; // anim01→anim02 の間隔
  const REARM_PX       = 5;   // 再発火のためにセンターから離れる距離
  const CENTER_EPS     = 1;    // 「中央一致」とみなす許容誤差(px)

  // ===== ユーティリティ =====
  const asPromise = (fn) => {
    try {
      const ret = fn?.();
      if (ret && typeof ret.then === 'function') return ret;
      if (typeof ret === 'number' && isFinite(ret) && ret >= 0) {
        return new Promise(r => setTimeout(r, ret));
      }
      return Promise.resolve();
    } catch (e) { console.error(e); return Promise.resolve(); }
  };
  const wait = (ms) => (ms > 0 ? new Promise(r => setTimeout(r, ms)) : Promise.resolve());
  const deltaToCenter = () => {
    const rect = mv.getBoundingClientRect();
    const elemCenter = rect.top + rect.height / 2;
    const viewCenter = window.innerHeight / 2;
    return elemCenter - viewCenter; // 正: 要素中心が画面中央より下 / 負: 上
  };

  // ===== 状態 =====
  let running   = false;
  let ticking   = false;
  let lastY     = window.scrollY || window.pageYOffset || 0;
  let lastDelta = deltaToCenter();
  let armed     = Math.abs(lastDelta) > REARM_PX;

  const runSequence = async (direction /* 'down' | 'up' */) => {
    if (running) return;
    running = true;
    try {
      if (direction === 'down') {
        //await controller?.abort();
        await asPromise(window.anim01);                // 付与
        await wait(SEQUENCE_GAP_MS);
        await asPromise(window.anim02);                // 小→大 付与
      } else {
        await asPromise(() => window.anim02?.({ reverse: true })); // 大→小 除去
        await wait(SEQUENCE_GAP_MS);
        await asPromise(() => window.anim01?.({ reverse: true })); // 除去
        //await startSlide();
      }
    } finally {
      running = false;
      armed = false; // 直後の揺れで再発火しない
    }
  };

  const onScrollRaf = () => {
    ticking = false;

    const y   = window.scrollY || window.pageYOffset || 0;
    const dir = (y > lastY) ? 'down' : (y < lastY) ? 'up' : null;
    const d   = deltaToCenter();

    if (Math.abs(d) > REARM_PX) armed = true;

    if (!running && armed && dir) {
      // 下方向で中心を跨いだ（+ → 0/−）
      if (dir === 'down' && lastDelta > 0 && d <= 0) {
        runSequence('down');
      }
      // 上方向で中心を跨いだ（− → 0/+）
      else if (dir === 'up' && lastDelta < 0 && d >= 0) {
        runSequence('up');
      }
    }

    lastY = y;
    lastDelta = d;
  };

  const onScroll = () => {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(onScrollRaf);
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', () => { lastDelta = deltaToCenter(); }, { passive: true });

  // ===== 初回読み込み時：中央一致なら即発火（順方向） =====
  // レイアウトが安定してから判定したいので rAF を2回回して測定
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      lastDelta = deltaToCenter();
      // 中央一致（±CENTER_EPS）ならスクロール不要で発火
      if (Math.abs(lastDelta) <= CENTER_EPS && !running) {
        armed = true;              // 念のため armed にしておく
        runSequence('down');       // 初回は順方向で開始
      } else {
        // そうでなければ通常の初期評価
        onScrollRaf();
      }
    });
  });
});


// =================================================
// ヘッダー
// =================================================

